import { CouponOfferType } from '@shared/constants';
import { CouponDTO } from '@shared/dto';

export class Coupon {
  campaignId: number;
  offerId: number;
  label: string | null;
  rank: number;
  minimumUnits: number | null;
  minimumProductSpend: number;
  amountReward: number;
  percentageReward: number | null;
  fixedPrice: number | null;
  offerType: CouponOfferType;
  rewardEarned: number;
  loadingDate: string | null;
  redemptionDate: string | null;
  logo: string;
  additionalInformation: string | null;
  /**
   * Defaults to a non-zero stock, so a coupon whose stock the API does not
   * report stays visible. The b2c-api omits `remaining_selections` on some
   * allocations; reading that as 0 makes `inStock` false and
   * `CouponsStateService.setCoupons` then filters out every coupon of a
   * freshly allocated campaign. Same defensive default as `Challenge`.
   */
  remainingSelections = 1000;

  constructor(couponsDTO: CouponDTO) {
    this.campaignId = couponsDTO.campaign_id;
    this.offerId = couponsDTO.offer_id;
    this.label = couponsDTO.label;
    this.rank = couponsDTO.rank;
    this.minimumUnits = couponsDTO.minimum_units;
    this.minimumProductSpend = couponsDTO.minimum_product_spend;
    this.amountReward = couponsDTO.amount_reward;
    this.percentageReward = couponsDTO.percentage_reward;
    this.fixedPrice = couponsDTO.fixed_price;
    this.offerType = couponsDTO.offer_type;
    this.rewardEarned = couponsDTO.reward_earned;
    this.loadingDate = couponsDTO.loading_date;
    this.redemptionDate = couponsDTO.redemption_date;
    this.logo = couponsDTO.logo_path;
    this.additionalInformation = couponsDTO.additional_information;
    this.remainingSelections =
      couponsDTO.remaining_selections ?? this.remainingSelections;
  }

  get isLoaded(): boolean {
    return !!this.loadingDate;
  }

  get isRedeemed(): boolean {
    return this.isLoaded && !!this.redemptionDate;
  }

  get inStock(): boolean {
    return this.remainingSelections > 0;
  }
}
